import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { IrohNode, ProjectIdParam } from "@/types"

// Define a service using a base URL and expected endpoints
export const irohNodesApi = createApi({
  reducerPath: "irohNodesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}iroh-nodes`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    irohNodesGet: build.query<
      IrohNode[],
      ProjectIdParam & { offset: number; limit: number }
    >({
      query: ({ project_id, offset, limit }) => ({
        url: `${project_id}?offset=${offset}&limit=${limit}`,
      }),
    }),
    irohNodeGet: build.query<IrohNode, ProjectIdParam & { node_id: string }>({
      query: ({ project_id, node_id }) => `${project_id}/${node_id}`,
    }),
  }),
})

export const { useIrohNodesGetQuery, useIrohNodeGetQuery } = irohNodesApi
